import React from 'react';
import { useStepupContext } from './context/stepup-context';

import { StepupOfferDialog } from './stepup-offer-dialog';
import { useAutoOpenModal } from './lib/use-auto-open-stepup';

import { OfferPreviewDialog } from './offer-preview-dialog';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';
import { useTranslations } from 'next-intl';
import { FacebookLogin } from '../auth/facebook-login';
import { ScopelyLogin } from '../auth/scopely-login';
import { LoginDialog } from '../../../../../packages/ui/features/auth';

export const StepupOfferDialogContent = () => {
  const t = useTranslations();
  const isAuthenticated = useIsAuthenticated();
  const {
    isModalOpen,
    stepupInfo,
    focusedOffer,
    processingModalOpen,
    closeModal,
  } = useStepupContext();

  useAutoOpenModal();
  if (!isModalOpen || !stepupInfo || processingModalOpen) {
    return <></>;
  }

  if (!isAuthenticated) {
    return (
      <LoginDialog
        title={t('stepup_login_description')}
        open
        onClose={closeModal}
        loginButtons={
          <>
            <FacebookLogin />
            <ScopelyLogin />
          </>
        }
      />
    );
  }

  return focusedOffer ? <OfferPreviewDialog /> : <StepupOfferDialog />;
};
